import type {
  LivestockInfo,
  LivestockInfoFromFarm,
  WeightGainCurve,
} from "shared/types";
import {
  LIST_FARM_WEIGHT_GAIN_CURVES,
  LIST_LIVESTOCK_INFOS_FROM_CORRALS,
  LIST_LIVESTOCK_INFOS_FROM_FARM,
  type LivestockDispatchAction,
} from "../actions/livestockActions";

export type LivestockState = {
  farmWeightGainCurves: WeightGainCurve[];
  infosFromCorrals: LivestockInfo[];
  infosFromFarm: LivestockInfoFromFarm[];
};

export const initialState: LivestockState = {
  farmWeightGainCurves: [],
  infosFromCorrals: [],
  infosFromFarm: [],
};

export default function livestockReducer(
  state: LivestockState = initialState,
  action: LivestockDispatchAction
): LivestockState {
  if (action.type === LIST_LIVESTOCK_INFOS_FROM_CORRALS) {
    return {
      ...state,
      infosFromCorrals: action.payload.infos,
    };
  }

  if (action.type === LIST_FARM_WEIGHT_GAIN_CURVES) {
    return {
      ...state,
      farmWeightGainCurves: action.payload.weightGainCurves,
    };
  }

  if (action.type === LIST_LIVESTOCK_INFOS_FROM_FARM) {
    return {
      ...state,
      infosFromFarm: action.payload.infos,
    };
  }

  return { ...state };
}
